/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RecipientEntityType = {
    ClientProfile: 0
} as const;
export type RecipientEntityType = typeof RecipientEntityType[keyof typeof RecipientEntityType];

